import React from 'react'

const Footer = () => {
  return (
    <footer>
      <div>
        <h1>Shayanlab.</h1>
        <p>@all right reserved</p>
      </div>

      <div>
        <h5>Follow Us</h5>
        <div>
          <a href="https://www.linkedin.com/in/shayan-giri-556757114/" target={"blank"}>
            Linkedin
          </a>
          <a href="https://www.instagram.com/___0shaan0___/" target={"blank"}>
            Instagram
          </a>
          <a href="https://github.com/Shayangiri49" target={"blank"}>
            Github
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer